import Vue from 'vue'
import Vuex from 'vuex'

import ibps from './modules/ibps'
import report from './modules/report'
import uniedp from './modules/uniedp'
import getters from './getters'
Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    ibps,
    report,
    uniedp
  },
  getters
})
